// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__7caDW","key":"styles_key__VqMhC","value":"styles_value__3QmL3"};
module.exports.__checksum = "78e672362817"